import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppRoutes from './AppRoutes';
import { ClaimListProvider } from './context/ClaimListContext';
import { NavigationProvider } from './context/NavigationContext';
import { DeviceProvider, useDevice } from './context/DeviceContext';
import { MobileVersionProvider } from './context/MobileVersionContext';
import { FolderAccessProvider } from './context/FolderAccessContext';
import { ActionsProvider } from './context/ActionsContext';

const AppContent: React.FC = () => {
    const location = useLocation();
    const { deviceInfo } = useDevice();

    useEffect(() => {
        if (deviceInfo.isMobile) {
            if (location.pathname.startsWith('/hospvisit') || location.pathname.startsWith('/emr')) {
                toast.info('👋 For a better experience, use the Mobile App! (at /mobile)', {
                    position: 'top-center',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }, [location, deviceInfo.isMobile]);

    return (
        <ActionsProvider>
            <FolderAccessProvider>
                <ClaimListProvider>
                    <NavigationProvider>
                        <AppRoutes />
                        <ToastContainer />
                    </NavigationProvider>
                </ClaimListProvider>
            </FolderAccessProvider>
        </ActionsProvider>
    );
};

const App: React.FC = () => {
    return (
        <DeviceProvider>
            <MobileVersionProvider>
                <AppContent />
            </MobileVersionProvider>
        </DeviceProvider>
    );
};

export default App;
